
import { computed, defineComponent, ref, watch } from 'vue'
import MobileAnimationService from '@/services/form/mobile-animation.service'
import { useStore } from '@/store'

export default defineComponent({
  name: 'FormScrollableTab',
  props: {
    index: Number,
    configName: {
      required: true,
      type: String
    }
  },
  setup(props) {
    const store = useStore()
    const currentTab = computed(() => store.getters.currentTab)
    const configLoaded = computed(() => store.getters.configLoaded)
    const config = computed(() => store.getters[props.configName])
    const root = ref(null)
    const mobileAnimationService = new MobileAnimationService()

    // prettier-ignore
    watch(() => root.value, (_) => {
      mobileAnimationService.scrollToOption(root.value, config.value)
    })

    // prettier-ignore
    watch(() => configLoaded.value, (_) => {
      setTimeout(() => {
        if(config) {
          mobileAnimationService.scrollToOption(root.value, config.value)
        }
      }, 150)
    })

    return {
      root,
      currentTab
    }
  }
})
